function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.13 9.9v12.52a.46.46 0 0 1-.43.48h-7.14a.46.46 0 0 1-.43-.48V9.9zm1-1h-10v13.52a1.45 1.45 0 0 0 1.43 1.48h7.14a1.45 1.45 0 0 0 1.43-1.48z",
  style: {
    fill: "#1d1d1b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.94 4.13 19.25 6a.56.56 0 0 1-.09.33l-.83 1.45-3.47-2 .83-1.45a.66.66 0 0 1 .25-.24m0-1a1.39 1.39 0 0 0-1.13.75L14 5.32l-2.6-1.5-.5.86 2.6 1.5 5.19 3 2.6 1.5.5-.86-2.6-1.5.81-1.45a1.21 1.21 0 0 0-.19-1.65l-3.47-2a.8.8 0 0 0-.4-.1ZM13.64 19.68c-.28 0-.5-.14-.5-.32V13c0-.18.22-.32.5-.32s.5.14.5.32v6.36c0 .18-.23.32-.5.32M16.63 19.68c-.28 0-.5-.14-.5-.32V13c0-.18.22-.32.5-.32s.5.14.5.32v6.36c0 .18-.22.32-.5.32",
  style: {
    fill: "#1d1d1b"
  }
}));
export default SvgTrash;